import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  const isMobile = window.innerWidth <= 768;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#2a4071",
        padding: 100,
      }}
    >
      <div
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            height: "60%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            style={{
              height: isMobile ? "50px" : "80px",
              width: "auto",
              objectFit: "contain",
            }}
            src={"images/simpleman-white.png"}
            alt="Logo Simpleman"
          />
          <h1 style={{ color: "white", fontSize: 38 }}>Privacy Policy</h1>
          <p
            style={{
              color: "white",
              width: "60%",
              textAlign: "justify",
              lineHeight: 1.5,
            }}
          >
            <strong>INFORMATIVA COOKIES</strong> La presente informativa, resa
            ai sensi dell'art. 1 del D.Lgs. 196/2003 (Codice Privacy) e del
            Regolamento UE 2016/679 (GDPR), descrive le modalità di gestione dei
            cookies del presente sito web.
            <br /> <br />
            <b>1. COSA SONO I COOKIES</b>
            <br /> I cookies sono piccoli file di testo che i siti visitati
            inviano al dispositivo dell'utente, dove vengono memorizzati per
            essere ritrasmessi agli stessi siti alla visita successiva. Come
            stabilito dall'art. 122 del Codice Privacy, l'archiviazione di
            informazioni nell'apparecchio terminale di un utente o l'accesso a
            informazioni già archiviate sono consentiti unicamente a condizione
            che l'utente abbia espresso il proprio consenso dopo essere stato
            informato con modalità semplificate.
            <br /> <br /> <b>2. TIPOLOGIE DI COOKIES UTILIZZATI</b>
            <br /> Il sito utilizza le seguenti categorie di cookies:
            <br /> a) <b>Cookies tecnici:</b> sono necessari per il corretto
            funzionamento del sito e per permettere la navigazione; senza di
            essi potresti non essere in grado di visualizzare correttamente le
            pagine oppure di utilizzare alcuni servizi. Ai sensi dell'art. 122
            comma 1 del Codice Privacy, per questi cookies non è richiesto il
            consenso dell'utente quando sono strettamente necessari per la
            trasmissione di una comunicazione su una rete di comunicazione
            elettronica o per erogare un servizio esplicitamente richiesto
            dall'utente. <br />
            b) <b>Cookies analitici:</b> sono utilizzati per raccogliere
            informazioni sull'utilizzo del sito, come le pagine visitate o
            eventuali errori che si possono incontrare durante la navigazione.
            Questi cookies raccolgono informazioni in forma anonima. <br />
            c)<b> Cookies di profilazione:</b> sono volti a creare profili
            relativi all'utente e vengono utilizzati al fine di inviare messaggi
            pubblicitari in linea con le preferenze manifestate dallo stesso
            nell'ambito della navigazione in rete.
            <br /> <br />
            <b> 3. BASE GIURIDICA DEL TRATTAMENTO </b>
            <br /> Come previsto dall'art. 7 del GDPR, il trattamento dei dati
            personali è lecito solo se l'interessato ha espresso il proprio
            consenso. Il consenso deve essere: - Libero e specifico; -
            Informato; - Inequivocabile; - Revocabile in qualsiasi momento.
            <br /> <br /> <b>4. MODALITÀ DEL TRATTAMENTO</b>
            <br /> Conformemente a quanto previsto dall'art. 30 del GDPR, il
            trattamento dei dati personali avviene mediante strumenti
            informatici nel rispetto delle disposizioni in materia di protezione
            dei dati personali e, in particolare, delle misure di sicurezza
            tecniche e organizzative adeguate. <br /> <br />
            <b>5. DIRITTI DELL'INTERESSATO</b>
            <br /> Ai sensi dell'art. 15 del GDPR, l'utente ha il diritto di: -
            Ottenere la conferma dell'esistenza o meno di dati personali che lo
            riguardano; - Conoscere le finalità del trattamento; - Conoscere le
            categorie di dati personali trattati; - Conoscere i destinatari o le
            categorie di destinatari a cui i dati sono stati o saranno
            comunicati; - Conoscere il periodo di conservazione dei dati o i
            criteri utilizzati per determinarlo; - Ottenere la rettifica o la
            cancellazione dei dati; - Ottenere la limitazione del trattamento; -
            Opporsi al trattamento; - Proporre reclamo a un'autorità di
            controllo;
            <br /> <br /> <b>6. GESTIONE DEI COOKIES</b>
            <br /> Come stabilito dalla giurisprudenza (Cassazione civile n.
            17278/2018), il consenso deve essere prestato liberamente e
            specificamente in riferimento a un trattamento chiaramente
            individuato. L'utente può scegliere quali cookies accettare
            attraverso le apposite funzioni del browser. Di seguito le modalità
            offerte dai principali browser: - Chrome: Impostazioni → Privacy e
            sicurezza → Cookie e altri dati dei siti; - Firefox: Opzioni →
            Privacy & Sicurezza → Cookie e dati dei siti; - Safari: Preferenze →
            Privacy; - Edge: Impostazioni → Privacy, ricerca e servizi → Cookie
            e autorizzazioni sito. <br /> <br />
            <b>7. TITOLARE DEL TRATTAMENTO</b>
            <br /> Il Titolare del trattamento è Sacel srl in persona del legale
            rappresentante p.t. con sede legale in Matera, alla Zona Ind. La
            Martella, P. IVA n. 00356580779, contattabile ai seguenti recapiti:
            info@sacelsrl.it.
            <br /> <br /> <b>8. AGGIORNAMENTI </b>
            <br />
            La presente informativa può essere soggetta ad aggiornamenti. Gli
            utenti sono pertanto invitati a verificarne periodicamente il
            contenuto. Data ultimo aggiornamento: 10/03/2025.
          </p>
        </div>
        <Link
          to="/"
          style={{
            backgroundColor: "white",
            padding: 10,
            borderRadius: 5,
            textDecoration: "none",
            width: "fit-content",
          }}
        >
          {"Torna alla Home"}
        </Link>
      </div>
    </div>
  );
}
